// components/ExportToExcel.js
import { saveAs } from "file-saver";
import { FileDown } from "lucide-react";

// exceljs (~1 Mo) ne sert qu'au moment du clic sur "Exporter", mais importé
// en haut de fichier il était embarqué dans le bundle initial — donc
// téléchargé et analysé par tout le monde, même sans jamais exporter.
// Chargé à la demande ici : le bouton se comporte exactement pareil, le coût
// n'est payé que par celui qui exporte. Même traitement dans Admin/ImportMEG.js,
// l'autre point d'entrée d'exceljs — sans quoi il resterait dans le bundle.
const ExportToExcel = ({ data, fileName }) => {
  const exportToExcel = async () => {
    // exceljs est du CommonJS pur : selon l'interop du bundler, le module
    // arrive soit sur `default`, soit à la racine. On accepte les deux plutôt
    // que de faire dépendre le bouton d'un détail de build.
    const mod = await import("exceljs");
    const ExcelJS = mod.default || mod;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Clients");

    if (data.length === 0) return;

    // Ajouter les entêtes avec style
    const headers = Object.keys(data[0]);
    worksheet.addRow(headers);
    const headerRow = worksheet.getRow(1);

    headerRow.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF003366" }, // Bleu marine pro
      };
      cell.font = {
        bold: true,
        color: { argb: "FFFFFFFF" }, // Texte blanc
        size: 12,
        name: "Calibri",
      };
      cell.alignment = { vertical: "middle", horizontal: "center" };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    // Ajouter les données
    data.forEach((item) => {
      worksheet.addRow(Object.values(item));
    });

    // Générer le fichier
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, `${fileName}.xlsx`);
  };

  return (
    <button
      onClick={exportToExcel}
      variant="outline"
      className={`flex items-center gap-2 h-9 px-4 rounded-md font-medium text-sm bg-white text-gray-700 border border-gray-300 hover:bg-gray-50`}
    >
      <FileDown className="w-4 h-4 mr-2" />
      Exporter
    </button>
  );
};

export default ExportToExcel;
